import {handleActions, createAction} from 'redux-actions';
import {
    axios,
    axiosWithoutHeaders
} from "../cores/axiosWrapper";

function getVideosAPI(stageId, apiEndpoint, projectId, params) {
    return axios.get(`${apiEndpoint}/videos`, {
        params,
        headers : {
            stageId,
            projectId
        }
    });
}

function getVideoAPI(stageId,apiEndpoint, projectId, videoId, params) {
    // TODO: Module쪽을 호출해서 사용하도록 수정
    return axios.get(`${apiEndpoint}/videos/${videoId}`, {
        params, 
        headers : {
            stageId,
            projectId
        }
    });
}
//action type
const LISTING_VIDEOS_PENDING = 'LISTINGS_VIDEOS_PENDING';
const LISTING_VIDEOS_FAILURE = 'LISTING_VIDEOS_FAILURE';
const GET_LISTING_VIDEOS_SUCCESS = 'GET_LISTING_VIDEOS_SUCCESS';
const SET_LISTING_VIDEO_DROP = 'SET_LISTING_VIDEO_DROP';
const RESET_VIDEO_LIST_DATA = 'RESET_VIDEO_LIST_DATA';
const SET_LISTING_VIDEO_SELECTED = 'SET_LISTING_VIDEO_SELECTED';
const GET_LISTING_VIDEO_SUCCESS = 'GET_LISTING_VIDEO_SUCCESS';
const DELETE_LISTING_VIDEO_SELECTED = 'DELETE_LISTING_VIDEO_SELECTED';
const UPDATE_LISTING_VIDEO_ITEM = 'UPDATE_LISTING_VIDEO_ITEM';
const SET_LISTING_VIDEO_INIT_ITEM = 'SET_LISTING_VIDEO_INIT_ITEM';
const SET_LISTING_VIDEO_COUNT = 'SET_LISTING_VIDEO_COUNT';
//reduceer
const initialState = {
    pending: false,
    error: false,
    data: [],
    selected : {
        id : '',
        name : '',
        start : '',
        end : '',
        duration : '',
        thumbnails : '',
        job : {},
        type : '',
        size : 0,
        tags : [],
        username : '',
        categories : []
    },
    standardDateTime : null,
    counts : {
        detail : 0,
        list : 0
    },
    item : null,
    totalCount: 0
};
//TODO initialstate 가 형태가 같은 타입일 경우 동일하다..이를 구조화하는 방법을 찾아보자.

export default handleActions({
    [LISTING_VIDEOS_PENDING]: (state) => {
        return {
            ...state,
            pending: true,
            error: false
        };
    },
    [LISTING_VIDEOS_FAILURE]: (state) => {
        return {
            ...state,
            pending: false,
            error: true
        };
    },
    [GET_LISTING_VIDEOS_SUCCESS]: (state, action) => {
        const {videos, totalCount} = action.payload.data;
        
        return {
            ...state,
            pending: false,
            data: videos ? videos.map(v => {
                return {
                    type : 'video',
                    isDropped : false,
                    ...v
                }
            }) : [],
            counts : {
                ...state.counts,
                list : state.counts + 1
            },
            totalCount
        };
    },
    [SET_LISTING_VIDEO_DROP]: (state, action) => {
        const {videoIds} = action.payload;

        return {
            ...state,
            data : state.data.map(v => {
                return {
                    ...v,
                    isDropped: videoIds.indexOf(v.id) !== -1
                }
            })
        }
    },
    [RESET_VIDEO_LIST_DATA]: (state) => {
        return {
            ...state,
            data : [],
            counts : {
                detail : 0,
                list : 0
            },
            totalCount : 0
        }
    },
    [SET_LISTING_VIDEO_SELECTED]:(state, action) => {
        return {
            ...state,
            selected: action.payload,
            counts : {
                ...state.counts,
                detail : state.counts.detail + 1
            }
        };
    },
    [GET_LISTING_VIDEO_SUCCESS]:(state, action) => {
        const {response, standardDateTime} = action.payload;

        return {
            ...state,
            pending: false,
            item: response.data,
            standardDateTime,
            counts : {
                ...state.counts,
                detail : state.counts.detail + 1
            }
        };
    },
    [DELETE_LISTING_VIDEO_SELECTED]: (state) => {
        return {
            ...state,
            selected : {
                id : '',
                name : '',
                start : '',
                end : '',
                format : '',
                duration : '',
                isEncrypted: 0,
                poster : '',
                size : 0,
                description : '',
                username : '',
                categories : []
            },
            item : null
        }
    },
    [UPDATE_LISTING_VIDEO_ITEM]:(state, action) => {
        return {
            ...state,
            item : {
                ...state.item,
                ...action.payload
            }
        }
    },
    [SET_LISTING_VIDEO_INIT_ITEM]:(state) => {
        return {
            ...state,
            pending:true,
            item : null
        }
    },
    [SET_LISTING_VIDEO_COUNT]:(state, action) => {
        return {
            ...state,
            counts : {
                ...state.counts,
                ...action.payload
            }
        }
    }
}, initialState);

export const resetVideoListData = createAction(RESET_VIDEO_LIST_DATA);
export const setVideoSelected = createAction(SET_LISTING_VIDEO_SELECTED);
export const setVideoDrop = createAction(SET_LISTING_VIDEO_DROP);
export const deletedVideoSelected = createAction(DELETE_LISTING_VIDEO_SELECTED);
export const getVideos = (params) => (dispatch, getState) => {
    const {
        stage,
        project
    } = getState();

    if (stage.id === '') {
        return;
    }

    dispatch({type: LISTING_VIDEOS_PENDING});

    return getVideosAPI(stage.id, stage.endpoint, project.id, params).then(
        (response) => {
            dispatch({
                type: GET_LISTING_VIDEOS_SUCCESS,
                payload: response
            });
        }
    ).catch(error => {
        dispatch({
            type: LISTING_VIDEOS_FAILURE,
            payload: error
        });
    });
};
export const getVideo = (videoId, standardDateTime) => (dispatch, getState) => {
    const {
        stage,
        project
    } = getState();

    if (stage.id === '') {
        return;
    }

    dispatch({type: SET_LISTING_VIDEO_INIT_ITEM});

    return getVideoAPI(stage.id, stage.endpoint, project.id, videoId, { 
        hasAssociations : true,
        generateAccessUrl: true 
    }).then(
        (response) => {
            dispatch({
                type: GET_LISTING_VIDEO_SUCCESS,
                payload: {
                    response,
                    standardDateTime
                }
            });
        }
    ).catch(error => {
        dispatch({
            type: LISTING_VIDEOS_FAILURE,
            payload: error
        });
    });
};
export const updateItem = createAction(UPDATE_LISTING_VIDEO_ITEM);
export const setVideoCount = createAction(SET_LISTING_VIDEO_COUNT);